module.exports = {
  EVENT_STATUS: {
    NEW: 'NEW',
    PROCESSING: 'PROCESSING',
    PROCESSED: 'PROCESSED',
    CANCELLED: 'CANCELLED'
  }
};
